import { FiltersPlugin, useGuiFilters } from "@me8eon/filters";
import { makeUseStateChild } from "@me8eon/context";
import { DataView, dataViewFilterName, useDataViews } from "@me8eon/data_views";

export type DataViewFilters = {
    [dataViewFilterName]: string
}

export const dataViewFilterPlugin: FiltersPlugin<DataViewFilters, "dataview"> = {
    plugin: "filter",
    type: dataViewFilterName,
    DefaultDisplay: null,
    changeCausesSubmit: false,
    deleteWhenClean: false,
};


export const useSelectedDataViewName =
    makeUseStateChild(useGuiFilters, lb => lb.focusOn(dataViewFilterName));

export function useSelectedDataView<SearchType extends string, DataSourceDetails>(): DataView<SearchType, DataSourceDetails> {
    const dataViews = useDataViews();
    const [selected] = useSelectedDataViewName();
    const dv = dataViews[selected];
    return dv;
}